<div>
  <bottom-sheet-title [title]="'Edit Entry'"></bottom-sheet-title>
  <div class="p-2">
    <div>
      <span class="text-gray-400 my-2 block">Amount</span>
      <input
        class="block w-full p-2 rounded"
        type="number"
        placeholder="Amount..."
        [(ngModel)]="newEntry.amount"
      />
    </div>
    <div>
      <span class="text-gray-400 my-2 block">Memo</span>
      <input
        class="block w-full p-2 rounded"
        type="text"
        placeholder="Memo..."
        [(ngModel)]="newEntry.memo"
      />
    </div>
    <div>
      <span class="text-gray-400 my-2 block">Date</span>
      <div class="block w-full p-2 rounded bg-white" (click)="pickerr.open()">
        {{ newEntry.date | date }}
      </div>
      <input
        matInput
        hidden
        [(ngModel)]="newEntry.date"
        [matDatepicker]="pickerr"
      />
      <mat-datepicker #pickerr touchUi="true"></mat-datepicker>
    </div>
  </div>
  <div>
    <div class="p-2">
      <span class="text-gray-400 my-2 block">Tags</span>
    </div>
    <mat-selection-list (selectionChange)="updateNewEntryTags($event)">
      @for (tag of this.data.tags; track tag.id) {
      <mat-list-option
        [value]="tag.id"
        [selected]="newEntry.tagIds.includes(tag.id!)"
        class="[&:nth-child(odd)]:bg-[var(--surface-color)]"
      >
        <span class="tag {{ getTagColor(tag, this.data.tags) }} text-black">{{
          tag.fullPath
        }}</span>
      </mat-list-option>
      }
    </mat-selection-list>
  </div>

  <div class="p-4 border-t border-b">
    <mat-icon class="text-red-500 align-middle mr-2">delete</mat-icon>
    <span class="text-red-500 align-middle" (click)="deleteEntry()"
      >Delete Entry</span
    >
  </div>

  <bottom-sheet-controls
    [submitText]="'Update'"
    (onCancel)="_bottomSheetRef.dismiss()"
    (onSubmit)="updateEntry()"
  ></bottom-sheet-controls>
</div>
